import { render, staticRenderFns } from "./envio_muestras.vue?vue&type=template&id=ceb70044&scoped=true"
import script from "./envio_muestras.vue?vue&type=script&lang=js"
export * from "./envio_muestras.vue?vue&type=script&lang=js"
import style0 from "./envio_muestras.vue?vue&type=style&index=0&id=ceb70044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb70044",
  null
  
)

export default component.exports